import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { router } from './router.js';
import { cmsAuthLevel } from '../routed/cms/common/helpers.js';
import './mainSidebar.js';
let MainLayout = class MainLayout extends LitElement {
    constructor() {
        super(...arguments);
        this.location = router.location;
        this.cmsAuthLevel = cmsAuthLevel() || {};
        this.isCmsRoute = false;
        this._onLocationChanged = () => {
            var _a, _b, _c;
            this.location = router.location;
            this.isCmsRoute = (_c = (_b = (_a = this.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.startsWith('/cms/')) !== null && _c !== void 0 ? _c : false;
            this.cmsAuthLevel = cmsAuthLevel() || {};
        };
    }
    createRenderRoot() {
        return super.createRenderRoot();
    }
    connectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.connectedCallback();
        this._onLocationChanged();
        window.addEventListener('vaadin-router-location-changed', this._onLocationChanged);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('vaadin-router-location-changed', this._onLocationChanged);
    }
    static get styles() {
        return css `
			:host {
				min-height: 100vh;
				display: block;
			}

			.container--app {
				min-height: 100vh;
				display: flex;
			}

			.container--content {
				background-color: #f7f7fa;
				padding: 33px 30px;
				flex: 1;
				min-width: 0;
				box-sizing: border-box;
			}

			.container--role {
				color: #00000070;
				font-weight: 600;
				text-align: right;
				font-size: 12px;
				position: absolute;
				right: 30px;
				user-select: none;
			}

			.role::first-letter {
				text-transform: uppercase;
			}
		`;
    }
    render() {
        var _a, _b, _c, _d;
        return html `
			<div class="container--app">
				<main-sidebar></main-sidebar>
				<div class="container--content">
					${this.isCmsRoute
            ? html ` <div class="container--role">
								${((_a = this.cmsAuthLevel) === null || _a === void 0 ? void 0 : _a.role)
                ? html `Role:
											<span class="role"
												>${((_b = this.cmsAuthLevel) === null || _b === void 0 ? void 0 : _b.role)
                    ? ((_c = this.cmsAuthLevel) === null || _c === void 0 ? void 0 : _c.role.charAt(0).toUpperCase()) +
                        ((_d = this.cmsAuthLevel) === null || _d === void 0 ? void 0 : _d.role.slice(1))
                    : null}</span
											>`
                : null}
						  </div>`
            : null}
					<slot></slot>
				</div>
			</div>
		`;
    }
};
__decorate([
    property({ type: Object })
], MainLayout.prototype, "location", void 0);
__decorate([
    state()
], MainLayout.prototype, "cmsAuthLevel", void 0);
__decorate([
    state()
], MainLayout.prototype, "isCmsRoute", void 0);
MainLayout = __decorate([
    customElement('main-layout')
], MainLayout);
export { MainLayout };
//# sourceMappingURL=mainLayout.js.map